export let baseUrl = process.env.VUE_APP_ENDPOINT;
export let wsBaseUrl = process.env.VUE_APP_WS_URL;
export let stripeKey = process.env.VUE_APP_STRIPE_KEY;